import apiEndpoints from './apiEndpoints';
import { postRequest } from './index';

export const submitMailInStorageRequest = (payload) => {
  postRequest(apiEndpoints.mailIn, payload);
};
